// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"870c51ef","258":"c3cb98aa","319":"d27dde9d","397":"417357e2","471":"a5d5d181","716":"78f68feb","729":"f494adf3","805":"fcb2c952"}[chunkId] + ".chunk.js";
};